(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legend-featured"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const track = root.querySelector('[data-lk-product-carousel]');
      if (!track || track.dataset.lkReady === 'true') return;
      track.dataset.lkReady = 'true';
      const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
      root.querySelector('[data-lk-carousel-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-lk-carousel-next]')?.addEventListener('click', () => move(1));
    };
    document.querySelectorAll('.lk-home-part--featured').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector?.('.lk-home-part--featured');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legend-free-mockup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-free-mockup]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-fm-form]');
      if (!form) return;
      const find = (selector) => root.querySelector(selector);
      const copy = (key) => root.querySelector(`[data-fm-copy="${key}"]`)?.textContent || '';
      const field = (name) => form.elements.namedItem(`contact[${name}]`);
      const value = (name) => String(field(name)?.value || '').trim();
      const demo = root.dataset.demo === 'true';
      const draftKey = `jerseykits:mockup:draft:${location.pathname}:${root.id}`;
      const storage = {
        get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
        set(key, data) { try { sessionStorage.setItem(key, JSON.stringify(data)); } catch {} },
        remove(key) { try { sessionStorage.removeItem(key); } catch {} }
      };
      const steps = [...root.querySelectorAll('[data-fm-step]')];
      const stepper = find('[data-fm-stepper]');
      const next = find('[data-fm-next]');
      const back = find('[data-fm-back]');
      const submit = find('[data-fm-submit]');
      const content = find('[data-fm-form-content]');
      const status = find('[data-fm-status]');
      const error = find('[data-fm-error]');
      let currentStep = 0;
      let files = [];
      let busy = false;
      let activeController;
      const setError = (message) => {
        error.textContent = message;
        error.hidden = !message;
        if (message) error.focus();
      };
      const setStatus = (message) => {
        status.textContent = message;
        status.hidden = !message;
      };
      const uploadEndpoint = (() => {
        if (!root.dataset.uploadEndpoint) return null;
        try {
          const url = new URL(root.dataset.uploadEndpoint, location.origin);
          return url.protocol === 'https:' || url.origin === location.origin ? url : null;
        } catch { return null; }
      })();
      const saveDraft = () => {
        const fields = {};
        [...form.elements].forEach((element) => {
          if (!element.name?.startsWith('contact[') || ['file', 'submit', 'button', 'hidden'].includes(element.type)) return;
          if (['radio', 'checkbox'].includes(element.type) && !element.checked) return;
          fields[element.name] = element.value;
        });
        storage.set(draftKey, { fields, reference: field('request_reference').value, time: Date.now() });
      };
      const restore = storage.get(draftKey);
      if (restore?.time && Date.now() - restore.time < 86400000 && restore.fields && typeof restore.fields === 'object') {
        Object.entries(restore.fields).forEach(([name, data]) => {
          if (!name.startsWith('contact[') || typeof data !== 'string') return;
          const element = form.elements.namedItem(name);
          if (element && !['file', 'hidden', 'submit', 'button'].includes(element.type)) element.value = data;
        });
        if (typeof restore.reference === 'string') field('request_reference').value = restore.reference.slice(0, 40);
        setStatus(copy('draft_restored'));
      }
      const ensureReference = () => {
        if (field('request_reference').value) return;
        const random = new Uint32Array(2);
        crypto.getRandomValues(random);
        field('request_reference').value = `FM-${Array.from(random, (number) => number.toString(36)).join('').slice(0, 10).toUpperCase()}`;
      };
      ensureReference();
      const saveArtwork = () => {
        const uploaded = files.filter((file) => file.url);
        field('uploaded_artwork').value = uploaded.map((file) => `${file.name}: ${file.url}`).join('\n');
        storage.set(`${draftKey}:artwork`, { files: uploaded, reference: value('request_reference'), time: Date.now() });
      };
      const savedArtwork = storage.get(`${draftKey}:artwork`);
      if (savedArtwork?.reference === value('request_reference') && savedArtwork.time && Date.now() - savedArtwork.time < 86400000 && Array.isArray(savedArtwork.files)) {
        files = savedArtwork.files.slice(0, 3).filter((file) => {
          try { return typeof file.name === 'string' && Number.isFinite(file.size) && new URL(file.url).protocol === 'https:'; } catch { return false; }
        });
        saveArtwork();
        if (files.length) setStatus(copy('artwork_restored'));
      }
      const review = () => {
        const list = find('[data-fm-review]');
        list.replaceChildren();
        const selectedText = (name) => field(name)?.selectedOptions?.[0]?.textContent || value(name);
        const radioLabel = form.querySelector('input[name="contact[sport]"]:checked')?.closest('label')?.textContent.trim();
        const items = [
          [copy('summary_sport'), radioLabel],
          [copy('summary_product'), value('product')],
          [copy('summary_quantity'), value('quantity') ? selectedText('quantity') : ''],
          [copy('summary_date'), value('event_date')],
          [copy('summary_finish'), selectedText('finish')],
          [copy('summary_team'), value('team_name')],
          [copy('summary_artwork'), [files.map((file) => file.name).join(', '), value('artwork_link')].filter(Boolean).join(' · ')]
        ];
        ['front_name', 'front_number', 'back_name', 'back_number', 'logo_placement'].forEach((name) => {
          if (value(name)) items.push([field(name)?.labels?.[0]?.textContent || name, value(name)]);
        });
        items.forEach(([label, data]) => {
          if (!data) return;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = label;
          description.textContent = data;
          row.append(term, description);
          list.append(row);
        });
        find('[data-fm-review-message]').textContent = value('body');
      };
      const showStep = (index, focus = true) => {
        currentStep = Math.max(0, Math.min(steps.length - 1, index));
        steps.forEach((step, number) => { step.hidden = number !== currentStep; });
        [...stepper.children].forEach((item, number) => {
          item.classList.toggle('is-active', number === currentStep);
          item.classList.toggle('is-complete', number < currentStep);
          if (number === currentStep) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        back.hidden = currentStep === 0;
        next.hidden = currentStep === steps.length - 1;
        submit.hidden = currentStep !== steps.length - 1;
        if (currentStep === steps.length - 1) review();
        if (focus) {
          const target = steps[currentStep].querySelector('input:not([type="hidden"]), select, textarea');
          target?.focus({ preventScroll: true });
          stepper.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      };
      const validate = (scope) => {
        const artwork = field('artwork_link');
        artwork.setCustomValidity('');
        if (artwork.value) {
          try {
            const url = new URL(artwork.value);
            if (!['https:', 'http:'].includes(url.protocol)) artwork.setCustomValidity(copy('link_invalid'));
          } catch { artwork.setCustomValidity(copy('link_invalid')); }
        }
        const invalid = [...scope.querySelectorAll('input, select, textarea')].find((element) => !element.checkValidity());
        if (!invalid) return true;
        const step = invalid.closest('[data-fm-step]');
        if (step) showStep(Number(step.dataset.fmStep), false);
        const details = invalid.closest('details');
        if (details) details.open = true;
        invalid.reportValidity();
        invalid.focus();
        return false;
      };
      form.noValidate = true;
      stepper.hidden = false;
      find('[data-fm-review-block]').hidden = false;
      find('[data-fm-clear]').hidden = false;
      find('[data-fm-demo-note]').hidden = !demo;
      find('[data-fm-uploader]').hidden = !demo && !uploadEndpoint;
      showStep(0, false);
      const dateInput = field('event_date');
      const now = new Date();
      dateInput.min = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      next.addEventListener('click', () => {
        if (validate(steps[currentStep])) { saveDraft(); showStep(currentStep + 1); }
      });
      back.addEventListener('click', () => showStep(currentStep - 1));
      find('[data-fm-edit]').addEventListener('click', () => showStep(1));
      form.addEventListener('input', () => { saveDraft(); if (currentStep === 2) review(); });
      form.addEventListener('change', saveDraft);
      const productCard = find('[data-fm-product-card]');
      const clearProduct = () => {
        field('product').value = '';
        field('product_configuration').value = '';
        productCard.hidden = true;
        storage.remove(root.dataset.contextKey);
        saveDraft();
      };
      find('[data-fm-clear-product]').addEventListener('click', clearProduct);
      const productContext = storage.get(root.dataset.contextKey);
      let productSource = new URLSearchParams(location.search).get('product');
      if (!productSource && productContext?.time && Date.now() - productContext.time < 3600000) productSource = productContext.url;
      if (productSource) {
        try {
          const productURL = new URL(productSource, location.origin);
          if (productURL.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(productURL.pathname)) {
            productURL.search = '';
            productURL.hash = '';
            field('product').value = productURL.href;
            find('[data-fm-product-title]').textContent = productURL.pathname.split('/').filter(Boolean).pop().replaceAll('-', ' ');
            productCard.hidden = false;
            const allowedFields = ['team_name', 'front_name', 'front_number', 'back_name', 'back_number', 'logo_placement', 'finish'];
            let contextMatches = false;
            try { contextMatches = productContext?.url && new URL(productContext.url, location.origin).pathname === productURL.pathname; } catch {}
            if (contextMatches && productContext.time && Date.now() - productContext.time < 3600000) {
              if (typeof productContext.title === 'string') find('[data-fm-product-title]').textContent = productContext.title.slice(0, 300);
              allowedFields.forEach((name) => {
                if (typeof productContext.fields?.[name] === 'string') field(name).value = productContext.fields[name].slice(0, 500);
              });
              if (productContext.configuration && typeof productContext.configuration === 'object') field('product_configuration').value = JSON.stringify(productContext.configuration).slice(0, 5000);
            }
            if (!demo) {
              fetch(`${productURL.pathname.replace(/\/$/, '')}.js`, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : null).then((product) => {
                if (!product || productCard.hidden) return;
                find('[data-fm-product-title]').textContent = product.title;
                const imageURL = new URL(product.featured_image || '', location.origin);
                if (product.featured_image && imageURL.protocol === 'https:') {
                  const image = find('[data-fm-product-image]');
                  image.src = imageURL.href;
                  image.alt = product.title;
                  image.hidden = false;
                }
              }).catch(() => {});
            }
          }
        } catch {}
      }
      const renderFiles = () => {
        const list = find('[data-fm-files]');
        list.replaceChildren();
        files.forEach((file, index) => {
          const row = document.createElement('li');
          row.className = 'fm-file';
          const label = document.createElement('span');
          label.textContent = `${file.name} · ${(file.size / 1048576).toFixed(1)} MB`;
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = '×';
          button.setAttribute('aria-label', `${copy('file_remove')}: ${file.name}`);
          button.addEventListener('click', () => {
            files.splice(index, 1);
            saveArtwork();
            renderFiles();
            setError('');
            find('[data-fm-file-input]').focus();
          });
          row.append(label, button);
          list.append(row);
        });
      };
      renderFiles();
      const addFiles = (incoming) => {
        if (busy) return;
        const additions = [...incoming].filter((file) => !files.some((current) => current.name === file.name && current.size === file.size && current.lastModified === file.lastModified));
        const allowed = new Set(['image/png', 'image/jpeg', 'application/pdf']);
        if (files.length + additions.length > 3 || additions.some((file) => file.size === 0 || file.size > 10485760 || !allowed.has(file.type) || !/\.(png|jpe?g|pdf)$/i.test(file.name))) {
          setError(copy('file_invalid'));
          return;
        }
        files.push(...additions);
        saveArtwork();
        renderFiles();
        setError('');
      };
      const fileInput = find('[data-fm-file-input]');
      fileInput.addEventListener('change', () => { addFiles(fileInput.files); fileInput.value = ''; });
      const dropzone = find('[data-fm-dropzone]');
      ['dragenter', 'dragover'].forEach((event) => dropzone.addEventListener(event, (e) => { e.preventDefault(); dropzone.classList.add('is-dragging'); }));
      ['dragleave', 'drop'].forEach((event) => dropzone.addEventListener(event, (e) => { e.preventDefault(); dropzone.classList.remove('is-dragging'); }));
      dropzone.addEventListener('drop', (event) => addFiles(event.dataTransfer.files));
      find('[data-fm-clear]').addEventListener('click', () => {
        form.reset();
        ensureReference();
        files = [];
        renderFiles();
        clearProduct();
        field('uploaded_artwork').value = '';
        storage.remove(draftKey);
        storage.remove(`${draftKey}:artwork`);
        setStatus(copy('draft_cleared'));
        setError('');
        showStep(0);
      });
      find('[data-fm-return]').addEventListener('click', () => {
        find('[data-fm-demo-success]').hidden = true;
        form.hidden = false;
        showStep(2);
      });
      const setBusy = (state) => {
        busy = state;
        form.setAttribute('aria-busy', String(state));
        root.querySelectorAll('button, input[type="file"]').forEach((element) => { element.disabled = state; });
        root.querySelectorAll('[data-fm-step] input, [data-fm-step] textarea').forEach((element) => {
          if (element.type !== 'radio') element.readOnly = state;
        });
      };
      form.addEventListener('submit', async (event) => {
        if (form.dataset.readyToSend === 'true') return;
        event.preventDefault();
        if (busy) return;
        if (currentStep < steps.length - 1) {
          if (validate(steps[currentStep])) showStep(currentStep + 1);
          return;
        }
        if (!validate(form)) return;
        saveDraft();
        setError('');
        if (demo) {
          form.hidden = true;
          const success = find('[data-fm-demo-success]');
          success.hidden = false;
          success.focus();
          success.scrollIntoView({ behavior: 'instant', block: 'center' });
          return;
        }
        setBusy(true);
        try {
          const pendingFiles = files.filter((file) => !file.url);
          if (pendingFiles.length) {
            if (!uploadEndpoint) throw new Error('Missing uploader');
            setStatus(copy('uploading'));
            const payload = new FormData();
            pendingFiles.forEach((file) => payload.append('files', file, file.name));
            payload.append('request_reference', field('request_reference').value);
            activeController = new AbortController();
            const timeout = setTimeout(() => activeController.abort(), 30000);
            let response;
            try {
              response = await fetch(uploadEndpoint, { method: 'POST', body: payload, credentials: uploadEndpoint.origin === location.origin ? 'same-origin' : 'omit', signal: activeController.signal });
            } finally { clearTimeout(timeout); }
            if (!response.ok) throw new Error('Upload rejected');
            const result = await response.json();
            if (!Array.isArray(result.files) || result.files.length !== pendingFiles.length) throw new Error('Missing artwork');
            const uploaded = result.files.map((file, index) => {
              const url = new URL(file.url);
              if (url.protocol !== 'https:') throw new Error('Invalid artwork URL');
              const original = pendingFiles[index];
              return { name: original.name, size: original.size, type: original.type, lastModified: original.lastModified, url: url.href };
            });
            files = [...files.filter((file) => file.url), ...uploaded];
            saveArtwork();
          }
          setStatus(copy('sending'));
          form.dataset.readyToSend = 'true';
          setBusy(false);
          HTMLFormElement.prototype.requestSubmit.call(form, submit);
        } catch {
          delete form.dataset.readyToSend;
          setBusy(false);
          setStatus('');
          showStep(1, false);
          setError(copy('upload_failed'));
        }
      });
      if (find('[data-fm-server-success]')) {
        content.hidden = true;
        storage.remove(draftKey);
        storage.remove(`${draftKey}:artwork`);
        storage.remove(root.dataset.contextKey);
        const reference = find('[data-fm-sent-reference]');
        if (reference && restore?.reference) {
          reference.textContent = restore.reference;
          find('[data-fm-reference-row]').hidden = false;
        }
        find('[data-fm-server-success]').focus();
      } else if (find('[data-fm-server-errors]')) {
        showStep(2, false);
        find('[data-fm-server-errors]').focus();
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legend-home-redesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const track = root.querySelector('[data-lk-product-carousel]');
      if (!track || track.dataset.lkReady === 'true') return;
      track.dataset.lkReady = 'true';
      const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
      root.querySelector('[data-lk-carousel-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-lk-carousel-next]')?.addEventListener('click', () => move(1));
    };
    document.querySelectorAll('.lk-home-redesign').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector?.('.lk-home-redesign');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legend-product-skin"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-lk-product-ui]').forEach((source) => {
        if (source.dataset.lkInstalled === 'true') return;
        const section = source.closest('.shopify-section');
        const main = section?.previousElementSibling?.querySelector('.product-information') || document.querySelector('.content-for-layout[data-template^="product"] .product-information');
        const form = main?.querySelector('.legend-form[data-config-id]');
        const appBlock = form?.closest('.shopify-app-block');
        const content = appBlock?.parentElement;
        const buyButtons = content?.querySelector('.buy-buttons-block');
        if (!main || !form || !appBlock || !content || !buyButtons) return;

        source.dataset.lkInstalled = 'true';
        const take = (name) => source.querySelector(`[data-lk-ui="${name}"]`);
        const header = take('header');
        const breadcrumb = take('breadcrumb');
        const eyebrow = take('eyebrow');
        const intro = take('intro');
        const mode = take('mode');
        const progress = take('progress');
        const team = take('team');
        const badge = take('badge');
        const guide = take('guide');
        const trust = take('trust');
        const service = take('service');
        const teamBanner = take('teamBanner') || take('team-banner') || take('banner');
        const footer = take('footer');
        const titleGroup = Array.from(content.children).find((element) => element.querySelector('h1'));
        const media = main.querySelector('.product-information__media');
        const firstSlide = media?.querySelector('slideshow-slide, .product-media-container');
        const page = main.closest('.content-for-layout');
        const mainSection = main.closest('.shopify-section');

        if (page && header) page.prepend(header);
        if (breadcrumb) main.before(breadcrumb);
        if (titleGroup && eyebrow) titleGroup.before(eyebrow);
        if (titleGroup && intro) titleGroup.after(intro);
        if (mode) appBlock.before(mode);
        if (progress) appBlock.before(progress);
        if (team) buyButtons.after(team);
        if (firstSlide && badge) firstSlide.append(badge);
        if (firstSlide && guide) firstSlide.append(guide);
        if (media && trust) media.append(trust);
        // Thứ tự như prototype: lưới sản phẩm → dải dịch vụ → khối chi tiết (section legend_details) → banner đội
        const detailsSection = mainSection ? mainSection.parentElement.querySelector('.shopify-section[id$="__legend_details"]') : null;
        if (mainSection && service) mainSection.after(service);
        if (teamBanner) { if (detailsSection) detailsSection.after(teamBanner); else if (service && service.parentElement) service.after(teamBanner); else if (mainSection) mainSection.after(teamBanner); }
        if (page && footer) page.append(footer);

        const modeButtons = mode ? Array.from(mode.querySelectorAll('[data-lk-mode]')) : [];
        const setMode = (nextMode) => {
          const isTeam = nextMode === 'team';
          appBlock.hidden = isTeam;
          buyButtons.hidden = isTeam;
          if (progress) progress.hidden = isTeam;
          if (team) team.hidden = !isTeam;
          modeButtons.forEach((button) => {
            const selected = button.dataset.lkMode === nextMode;
            button.setAttribute('aria-selected', String(selected));
            button.tabIndex = selected ? 0 : -1;
          });
        };
        modeButtons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.lkMode)));

        const steps = progress ? Array.from(progress.children) : [];
        form.addEventListener('focusin', (event) => {
          const groups = Array.from(form.querySelectorAll(':scope > .lg-group'));
          const index = groups.indexOf(event.target.closest('.lg-group'));
          if (index < 0) return;
          steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === Math.min(index, steps.length - 1)));
        });

        const previewTeam = guide?.querySelector('[data-lk-preview="team"]');
        const previewPlayer = guide?.querySelector('[data-lk-preview="player"]');
        const previewNumber = guide?.querySelector('[data-lk-preview="number"]');
        const bindPreview = () => {
          const teamInput = form.querySelector('.lg-field[data-key="team_name"] input');
          const playerInput = form.querySelector('.lg-field[data-key="back_name"] input');
          const numberInput = form.querySelector('.lg-field[data-key="back_number"] input') || form.querySelector('.lg-field[data-key="front_number"] input');
          if (!teamInput && !playerInput && !numberInput) return false;
          const updatePreview = () => {
            if (previewTeam) previewTeam.textContent = teamInput?.value.trim().toUpperCase() || 'TEAMNAME';
            if (previewPlayer) previewPlayer.textContent = playerInput?.value.trim().toUpperCase() || 'YOUR NAME';
            if (previewNumber) previewNumber.textContent = numberInput?.value.trim() || '00';
          };
          [teamInput, playerInput, numberInput].forEach((input) => {
            if (!input || input.dataset.lkPreviewBound === 'true') return;
            input.dataset.lkPreviewBound = 'true';
            input.addEventListener('input', updatePreview);
            input.addEventListener('change', updatePreview);
          });
          updatePreview();
          return true;
        };
        if (!bindPreview()) {
          const previewObserver = new MutationObserver(() => {
            if (bindPreview()) previewObserver.disconnect();
          });
          previewObserver.observe(form, { childList: true, subtree: true });
          window.setTimeout(() => {
            bindPreview();
            previewObserver.disconnect();
          }, 10000);
        }
        source.remove();
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', initialize);
    const observer = new MutationObserver(initialize);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
